// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:825px){.regular-logo{display:none}.small-logo{display:block}}.dark .logo-container :first-child,.dark .logo-container :nth-child(4){fill:#fff}.dark .logo-container :nth-child(5){fill:#162440}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
